<template>
  <li class="track-item" @click="$emit('select', track.id)">
    <div class="track-item-title">{{ track.name }}</div>
    <div class="track-item-meta track-item-subtitle">
      {{ formatDistance(track.distance_m) }} · {{ formatDuration(track.duration_s) }} ·
      {{ visibilityLabel(track.public) }}
    </div>

    <div class="track-item-body">
      <div class="track-preview-square">
        <img
          v-if="track.preview_url"
          :src="track.preview_url"
          :alt="track.name"
          loading="lazy"
        />
        <div v-else class="track-preview-placeholder" aria-hidden="true" />
      </div>
      <ul class="track-item-seasons">
        <li
          v-for="profile in orderedProfiles"
          :key="profile.season"
          class="track-item-meta"
        >
          {{ seasonLabel(profile.season) }}: {{ formatDifficultyProfile(profile) }}
        </li>
      </ul>
    </div>

    <div v-if="track.author" class="track-item-meta track-item-stats">
      {{ track.likes_count ?? 0 }} 👍 · {{ track.dislikes_count ?? 0 }} 👎 · {{ track.comments_count ?? 0 }} 💬 · {{ track.completions_count ?? 0 }} 🚙
    </div>
    <div v-if="track.author" class="track-item-meta track-item-author">
      <AuthorLink :author="track.author" prefix="Автор:" size="sm" stop-propagation />
    </div>
    <div v-if="showDelete" class="btn-row" style="margin-top: 0.75rem">
      <button class="btn btn-danger" @click.stop="$emit('delete', track.id)">
        Удалить
      </button>
    </div>
  </li>
</template>

<script setup>
import { computed } from 'vue'
import AuthorLink from './AuthorLink.vue'
import {
  SEASONS,
  formatDifficultyProfile,
  formatDistance,
  formatDuration,
  seasonLabel,
  visibilityLabel,
} from '../utils/trackFormat'

const props = defineProps({
  track: {
    type: Object,
    required: true,
  },
  showDelete: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['select', 'delete'])

const orderedProfiles = computed(() => {
  const profiles = props.track.difficulty_profiles || []
  const bySeason = Object.fromEntries(profiles.map((profile) => [profile.season, profile]))

  return SEASONS.map((season) => bySeason[season]).filter(Boolean)
})
</script>

<style scoped>
.track-item-subtitle {
  margin-top: 0.125rem;
  margin-bottom: 0;
}

.track-item-body {
  display: flex;
  gap: 0.75rem;
  margin-top: 0.5rem;
  align-items: flex-start;
}

.track-preview-square {
  width: 88px;
  height: 88px;
  border-radius: 0.375rem;
  overflow: hidden;
  flex-shrink: 0;
}

.track-preview-square img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.track-preview-placeholder {
  width: 100%;
  height: 100%;
  background: #f1f5f9;
}

.track-item-seasons {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1;
  min-width: 0;
}

.track-item-seasons li {
  line-height: 1.35;
}

.track-item-seasons li + li {
  margin-top: 0.125rem;
}

.track-item-stats {
  margin-top: 0.5rem;
}
</style>
